<template>
  <div class="taglist-container">
    <div ref="taglistDom" class="tag-list" :class="isOpen ? 'list-open' : ''">
      <span
        :class="{ 'active': input == item.no }"
        v-for="(item, index) in options"
        :key="index"
        @click="tagChange(item)"
        >{{ item.name }}</span
      >
    </div>
	<ToggleBtn v-if="isShow"  v-model="isOpen" />
  </div>
</template>

<script>
export default {
  name: "TagList",
  components: {
	  ToggleBtn: () => import('../components/toggleBtn.vue')
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
	  },
    isCondition: { // false-默认进入筛选条件初始化 
      type: Boolean,
      default: false
    },
    field: { // 字段名
      type: String,
      default: ''
    },
    childField: { // 联动子集选项字段
      type: Array,
      default: () => [],
    },
    dynamicChildField: { // 动态子集联动变化子集
      type: Object,
      default: () => null,
    },
    itemData: {
      type: Object,
      default: () => {},
    },
    options: { // 列表
      type: Array,
      default: () => [],
    },
    isForm: { // 是否是form表单
			type: Boolean,
      default: false
		},
  },
  data() {
    return {
      isOpen: false,
      // input: '',
      initValue: '',
      isShow: false, // 是否展示左侧展开隐藏按钮
      curentField: ''
    }
  },
  watch: {
    options: {
      handler() {
        new Promise(resolve => {
          this.$nextTick(() => {
            const taglistW = this.$refs.taglistDom.offsetWidth + 10
            let childW = 0
            for (const item of this.$refs.taglistDom.children) {
              childW += item.offsetWidth
            }
            resolve(taglistW < childW)
          })
        }).then(falg => {
          this.isShow = falg
        })
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    input: {
      get() {
        return this.initValue
      },
      set(val) {
        let res
        res = this.options.filter(item => {
          return item.no == val
        })
        const childField = val && this.dynamicChildField ? this.dynamicChildField[val] : this.childField
        const { type } = res && res[0]
        this.$emit('click', {...this.itemData, ...res[0], val: res[0].no || '', field: this.field, name: res[0].name, childField: childField, isForm: this.isForm, isCondition: this.isCondition, isOldType: !!type && +type !==  -1  })
      }
    }
  },
  mounted() {
    this.initValue = this.value
    this.curentField = this.field
	  let res
    res = this.options.filter(item => item.no === this.initValue)
    const { type } = res && res[0]
    this.$emit('initFormData', { ...this.itemData, val: res[0].no || '', field: this.field, name: res[0].name, childField: this.childField, isForm: this.isForm, isCondition: this.isCondition, isOldType: !!type && +type !==  -1 })
  },
  methods: {
    tagChange(item) {
      this.initValue = item.no
      this.input = item.no
    }
  },
};
</script>

<style lang="scss" scoped>
.taglist-container {
  background: #fff;
  padding-top: 10px;
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  &::before {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    content: '';
    border-bottom: 1px dashed #e4e7ed;
    z-index: 1;
  }
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    height: 40px;
    align-items: center;
   
    &.list-open {
      height: auto;
    }
    span {
      padding: 0 13px;
      font-size: 14px;
      color: #333;
      display: inline-block;
      line-height: 35px;
      text-align: center;
      cursor: pointer;
	    margin-bottom: 5px;
      &.active {
        background: #b79255;
        color: #ffffff !important;
        border-radius: 4px;
      }
    }
  }
}
</style>
